import { foundationDatePickerStyles } from '@genesislcap/foundation-ui';
import { css } from '@microsoft/fast-element';
import { ColorHEX } from '../_common';
export const zeroDatePickerStyles = () => css `
  ${foundationDatePickerStyles}
  :host {
    --primary-gradient-angle: -113.5deg;
  }

  .calendar-dropdown {
    background: ${ColorHEX.mediumGrey};
  }

  .week-days,
  .header h3,
  .header .months-arrows .icon-container zero-icon {
    color: var(--neutral-stroke-rest);
  }

  .header .months-arrows .icon-container {
    background-color: var(--neutral-layer-card-container);
  }

  .month-day.current {
    color: ${ColorHEX.almostWhite};
  }

  .input-icon-container {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: calc(var(--control-corner-radius) * 1px);
    width: 30px;
    height: 30px;
  }

  .input-icon-container:hover {
    background-color: ${ColorHEX.mediumGrey};
  }

  .date-toggle::part(end) {
    margin-inline-end: 4px;
  }
`;
